import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '影视分类',
    links: [
      { label: '电影', path: '/category/dianying' },
      { label: '电视剧', path: '/category/dianshiju' },
      { label: '综艺', path: '/category/zongyi' },
      { label: '动漫', path: '/category/dongman' },
      { label: '纪录片', path: '/category/jilupian' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '用户口碑', path: '/about#testimonials' },
      { label: '联系我们', path: '/about#contact' },
      { label: '常见问题', path: '/about#faq' },
    ],
  },
  {
    title: '用户服务',
    links: [
      { label: '意见反馈', path: '/about#contact' },
      { label: 'APP下载', path: '/' },
      { label: '播放帮助', path: '/about#faq' },
      { label: '版权声明', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                红桃影视
              </span>
            </Link>
            <p className="text-secondary-300 text-sm leading-relaxed">
              红桃影视 - 您的高清影视资源在线观看平台。海量电影、电视剧、综艺、动漫、纪录片，随时随地畅享精彩视听体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line text-background-50"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-medium text-background-50 mb-4 text-sm">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-secondary-300 hover:text-background-50 text-sm transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="py-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-secondary-400 text-xs">
            &copy; 2026 红桃影视 Hongtao Movies. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-secondary-400 hover:text-background-50 text-xs transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-secondary-400 hover:text-background-50 text-xs transition-colors cursor-pointer" rel="nofollow">用户协议</a>
            <a href="#" className="text-secondary-400 hover:text-background-50 text-xs transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}